// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__WoS1E","rotation":"Loader_rotation__AZZwQ"};